import React from 'react';
import { SelectProps } from 'antd/lib/select';

import {
    FormFieldWrapperProps,
    FormInputFieldWrapper,
} from 'app/components/common/inputs/common/input/form-input-field-wrapper';

import { SelectComponent } from './select-component';

const FormSelect: React.FC<FormFieldWrapperProps<SelectProps>> = (props: FormFieldWrapperProps<SelectProps>) => (
    <FormInputFieldWrapper {...props} component={SelectComponent} />
);

export { FormSelect };
